"use strict";

/**
 * JSON beautifier.
 *
 * @param data. Javascript Value that needs to converted to JSON string.
 * @param space. Default is 3. This is optional argument, Max is 10.
 * @return string.Formatted string that is easy to read on console/terminal.
 */

module.exports = function (data, space) {

    var spaces = space || 3;

    return JSON.stringify(data, null, spaces);

};


